import DB from "@/common/utils/db";
import {jsonp,commonParams, options} from "@/common/utils/jsonp";
/**
 * @description 获取专场列表
 */
export function getList(query={}) {
  let _url;
  if(!!location.host.match(/test|dev|local/)){
    _url = "//boot-restful-test.hunteron.com/activechannel/getActiveChannel";
  }else if(!!location.host.match(/uat/)){
    _url = '//boot-restful-uat.hunteron.com/activechannel/getActiveChannel';
  }else{
    _url = "//boot-restful.hunteron.com/activechannel/getActiveChannel";
  }
  const data = Object.assign({}, commonParams, query);
  return jsonp(_url, data, options);
}
/**
 * @description 获取专场职位列表
 */
export function getRecruitPositionList(id,query) {
  return DB({
    url: "v1/positions/recruit/"+id,
    method: "get",
    params: query
  });
}